module.exports = __WEBPACK_EXTERNAL_MODULE_24__;


//////////////////
// WEBPACK FOOTER
// external "angular-ui-router"
// module id = 24
// module chunks = 0